import React, { useState } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [sendingLink, setSendingLink] = useState(false);

  const handleMagicLinkRequest = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSendingLink(true);

    try {
      await api.post('/auth/magic-link', { email });
      setSuccess('Check your email! We have sent you a secure login link that will log you in automatically.');
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send login link. Please check your email address and try again.');
    } finally {
      setSendingLink(false);
    }
  };

  return (
    <Layout>
      <div style={{
        maxWidth: '450px',
        margin: '2rem auto',
        padding: '2.5rem',
        background: 'white',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '0.5rem', color: '#2c3e50', textAlign: 'center' }}>Client Portal Login</h2>
        <p style={{ marginTop: 0, marginBottom: '2rem', color: '#666', fontSize: '0.9rem', textAlign: 'center' }}>
          Enter your email to receive a secure login link
        </p>

        {error && (
          <div style={{
            padding: '1rem',
            background: '#fee',
            color: '#c00',
            borderRadius: '6px',
            marginBottom: '1.5rem',
            fontSize: '0.9rem'
          }}>
            {error}
          </div>
        )}

        {success && (
          <div style={{
            padding: '1.25rem',
            background: '#d4edda',
            color: '#155724',
            borderRadius: '6px',
            marginBottom: '1.5rem',
            fontSize: '0.9rem',
            lineHeight: '1.6'
          }}>
            <div style={{ fontWeight: '600', marginBottom: '0.5rem' }}>Email Sent!</div>
            {success}
          </div>
        )}

        <form onSubmit={handleMagicLinkRequest}>
          <div style={{
            marginBottom: '1rem',
            padding: '1rem',
            background: '#e3f2fd',
            borderRadius: '8px',
            fontSize: '0.9rem',
            color: '#1565c0',
            lineHeight: '1.6'
          }}>
            <div style={{ fontWeight: '600', marginBottom: '0.5rem' }}>Passwordless Login</div>
            We will email you a secure link that logs you in instantly. No password required!
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#2c3e50' }}>
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your.email@example.com"
              autoFocus
              style={{
                width: '100%',
                padding: '0.875rem',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '1rem',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#667eea'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <button
            type="submit"
            disabled={sendingLink}
            style={{
              width: '100%',
              padding: '1rem',
              background: sendingLink ? '#ccc' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: sendingLink ? 'not-allowed' : 'pointer',
              fontSize: '1rem',
              fontWeight: '600',
              transition: 'transform 0.2s',
              boxShadow: sendingLink ? 'none' : '0 4px 12px rgba(102, 126, 234, 0.4)'
            }}
            onMouseOver={(e) => !sendingLink && (e.target.style.transform = 'translateY(-2px)')}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            {sendingLink ? 'Sending...' : 'Send Login Link'}
          </button>
        </form>

        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          background: '#f9f9f9',
          borderRadius: '8px',
          fontSize: '0.85rem',
          color: '#666',
          lineHeight: '1.6'
        }}>
          <strong>How it works:</strong>
          <ol style={{ margin: '0.5rem 0 0 0', paddingLeft: '1.5rem' }}>
            <li>Enter your email address above</li>
            <li>Check your inbox for our email</li>
            <li>Click the secure link to log in instantly</li>
          </ol>
        </div>

        <p style={{
          marginTop: '1.5rem',
          textAlign: 'center',
          fontSize: '0.85rem',
          color: '#999'
        }}>
          Need help accessing your account?<br/>
          Contact us at <a href="mailto:info@goodwinbarrett.co.uk" style={{ color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>
            info@goodwinbarrett.co.uk
          </a>
        </p>
      </div>
    </Layout>
  );
};

export default Login;
